import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { CompPagFrete, infPagInterface } from "../../../interfaces";
import { useEffect, useState } from "react";
import { formatMoeda, getUuidV4, strToFloat } from "../../../utils/utils";
import { JConfirmDelete, MensagemModal } from "../../../components/Components";
import { TypeComponente } from "../../../lists";

const initialForm: CompPagFrete = {
    id: 0,
    tpComp: '01',
    vComp: 0,
    xComp: ''
}

interface formProps {
    form: infPagInterface;
    setForm: React.Dispatch<React.SetStateAction<infPagInterface>>
}

const Componente: React.FC<formProps> = ({ form, setForm }) => {

    const [component, setComponent] = useState<CompPagFrete>(initialForm);
    const [showAlert, setShowAlert] = useState<boolean>(false);
    const [messageAlert, setMessageAlert] = useState<string>('');
    const [selected, setSelected] = useState<number | string>(0);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [saldo, setSaldo] = useState<number>(form.vContrato);

    const alerta = (message: string) => {
        setMessageAlert(message);
        setShowAlert(true)
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setSelected(0);
    }

    const handleOpenModal = (id: number | string) => {
        setSelected(id);
        setShowModal(true);
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        setComponent((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleChangeNumeric = (e: any) => {
        const { name, value } = e.target;

        setComponent((prev) => ({
            ...prev,
            [name]: strToFloat(value)
        }))
    }

    const validarPreenchimento = () => {

        if (component.vComp === 0) {
            alerta('Informe o Vlr. do componente.');
            return false;
        }

        if (component.tpComp === '99') {
            if (component.xComp.trim() === "") {
                alerta('Informe a descrição do tipo Outro.');
                return false;
            }
        }

        if (saldo === 0) {
            alerta('A somatoria dos componentes atingiu o valor do contrato');
            return false;
        }

        if (component.vComp > saldo) {
            alerta('Vlr. do componente maior que o saldo restante. Informe o valor menor ou igual ao saldo.');
            return false;
        }

        setMessageAlert('');
        setShowAlert(false);
        return true
    }

    const handleAddComponent = () => {
        if (validarPreenchimento()) {
            setForm({
                ...form,
                comp: [...(form.comp || []), {
                    id: getUuidV4(),
                    tpComp: component.tpComp,
                    vComp: component.vComp,
                    xComp: component.xComp
                }]
            });

            setComponent(initialForm);
        }

    }

    const handleRemoveComponent = (id: number | string) => {

        setForm({
            ...form,
            comp: form.comp?.filter((item: CompPagFrete) => item.id !== id)
        })
        setShowModal(false);
        setSelected(0);
    }

    useEffect(() => {
        const total = form.comp?.map((item: CompPagFrete) => item.vComp)
            .reduce((total, num) => total + parseFloat(num.toFixed(2)), 0) || 0;
        setSaldo(form.vContrato - total);

    }, [form.vContrato, form.comp])

    return (<>
        <Row className="mb-3 g-2">
            <Col md={3}>
                <Form.Group>
                    <Form.Label>Tipo Componente</Form.Label>
                    <Form.Select name="tpComp" value={component.tpComp} onChange={(e) => {
                        setComponent({
                            ...component,
                            tpComp: e.target.value,
                            xComp: e.target.value != '99' ? '' : component.xComp
                        })
                    }}>
                        {TypeComponente.map(x => (
                            <option key={x.id} value={x.id}>{x.name}</option>
                        ))}

                    </Form.Select>
                </Form.Group>
            </Col>
            <Col md={3}>
                <Form.Group>
                    <Form.Label>Vlr Componente</Form.Label>
                    <Form.Control type="number" name="vComp" value={component.vComp} maxLength={16}
                        onChange={handleChangeNumeric}
                    />
                </Form.Group>
            </Col>

            {component.tpComp === '99' && (
                <Col md>
                    <Form.Group>
                        <Form.Label>Descrição do componente do tipo outros</Form.Label>
                        <Form.Control maxLength={60} name="xComp" value={component.xComp} onChange={handleChange} />
                    </Form.Group>
                </Col>
            )}

        </Row>
        <Row className="mb-3 g-2">

            <Col md={'auto'} className="d-flex align-items-end">
                <Button title="Adicionar componente" onClick={handleAddComponent}>
                    <FontAwesomeIcon icon={faPlus} /> Adicionar
                </Button>
            </Col>

            <Col md={'auto'} className="d-flex align-items-center mb-0">
                <Form.Label className="mb-0">Saldo Vlr Contrato</Form.Label>
            </Col>

            <Col md='4'>
                <Form.Control value={formatMoeda(saldo)} disabled />
            </Col>

        </Row>

        <Table striped bordered hover size="sm"  >
            <thead className="table-light">
                <tr>
                    <th className="text-center" style={{ width: '2.5rem' }}>#</th>
                    <th>Tipo Componente</th>
                    <th>Valor do componente</th>
                    <th>Descrição Outros</th>
                </tr>
            </thead>
            <tbody >
                {form.comp?.slice(0, 5).map((item: CompPagFrete) => (
                    <tr key={item.id} >
                        <td className="text-center">
                            <a href="javasctipt:void(0)" className="text-danger"
                                onClick={() => handleOpenModal(item.id)}>
                                <FontAwesomeIcon icon={faTrash} />
                            </a>
                        </td>
                        <td>{item.tpComp}</td>
                        <td>{item.vComp?.toLocaleString('pt-BR',
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                        )
                        }
                        </td>
                        <td>{item.xComp}</td>
                    </tr>
                ))}
            </tbody>
        </Table>

        <JConfirmDelete
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            handleDelete={handleRemoveComponent}
            selectedObject={''}
            id={selected}
        />

        <MensagemModal
            show={showAlert}
            handleClose={() => setShowAlert(false)}
            mensagem={messageAlert}
        />
    </>)
}

export default Componente;
